import type { BranchRepresentationType } from '@readme/api/src/mappings/branch/types';

import React, { useCallback } from 'react';

import Icon from '@ui/Icon';
import { MenuItem } from '@ui/Menu';

import { useDeleteBranchModalContext } from '../Modals/DeleteBranch';

interface DeleteBranchMenuItemProps {
  branch: BranchRepresentationType;
}

function DeleteBranchMenuItem({ branch }: DeleteBranchMenuItemProps) {
  const { setBranchToDelete } = useDeleteBranchModalContext();

  const handleDelete = useCallback(() => {
    setBranchToDelete(branch);
  }, [branch, setBranchToDelete]);

  return (
    <MenuItem
      aria-label="Delete Branch"
      color="red"
      icon={<Icon aria-hidden="true" name="trash" />}
      onClick={handleDelete}
      TagName="button"
    >
      Delete Branch
    </MenuItem>
  );
}

export default DeleteBranchMenuItem;
